const ColumnFilterProps = (dataIndex) => {
    return {
        onFilter: (value, record) => (record[dataIndex] ? record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()) : null),
    };
};

export default ColumnFilterProps;
